function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148704",
  d: "M7.659,16.918a1.032,1.032,0,0,0,.7-.369l2.093-1.888,3.709.006A2.429,2.429,0,0,0,16.823,12V7.589a2.429,2.429,0,0,0-2.665-2.671H6.927A2.431,2.431,0,0,0,4.262,7.589V12a2.426,2.426,0,0,0,2.626,2.665h.227v1.645C7.114,16.68,7.313,16.918,7.659,16.918ZM7.749,9.2A1.179,1.179,0,0,1,8.986,8a1.318,1.318,0,0,1,1.287,1.435,2.068,2.068,0,0,1-1.747,2.127.28.28,0,0,1-.3-.272c0-.136.068-.233.272-.284a1.563,1.563,0,0,0,1.043-.868H9.473a.82.82,0,0,1-.652.238A1.082,1.082,0,0,1,7.749,9.2Zm3.108,0A1.177,1.177,0,0,1,12.088,8a1.323,1.323,0,0,1,1.293,1.435,2.064,2.064,0,0,1-1.747,2.127.275.275,0,0,1-.295-.272c0-.136.068-.233.267-.284a1.563,1.563,0,0,0,1.043-.868h-.068a.825.825,0,0,1-.658.238A1.081,1.081,0,0,1,10.857,9.2Z",
  transform: "translate(-4.262 -4.918)",
  fill: "currentColor"
});

function SvgQuoteBubbleFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.561 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBubbleFilled);
export default __webpack_public_path__ + "static/media/quote-bubble-filled.0a4d5517.svg";
export { ForwardRef as ReactComponent };